import React from 'react';
import {
  Fab as MuiFab,
  FabProps as MuiFabProps,
  Tooltip,
} from '@mui/material';
import { StyledFab } from './Fab.style';

export interface FabProps extends MuiFabProps {
  /**
   * The tooltip text to display
   */
  tooltip?: string;
  /**
   * Whether the FAB should pulse
   */
  pulse?: boolean;
  /**
   * The position of the FAB when fixed
   */
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  /**
   * Whether the FAB should be fixed positioned
   */
  fixed?: boolean;
}

export const Fab: React.FC<FabProps> = ({
  children,
  tooltip,
  pulse = false,
  position = 'bottom-right',
  fixed = false,
  ...props
}) => {
  const fab = (
    <StyledFab
      pulse={pulse}
      position={position}
      fixed={fixed}
      {...props}
    >
      {children}
    </StyledFab>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow placement="left">
        {fab}
      </Tooltip>
    );
  }

  return fab;
}; 